// app/javascript/packs/poas.js
import Modal from "bootstrap/js/dist/modal";
import initImportFormDraft from "../import_form_draft";

// Devise vence la sesión tras 10 minutos sin requests. Escribir en el formulario
// no genera requests, por eso renovamos la sesión mientras exista actividad real
// en una pestaña visible con el formulario de POA abierto.
(function installPoaSessionKeepAlive() {
    if (window.__poaKeepAliveInstalled) return;
    window.__poaKeepAliveInstalled = true;

    const KEEP_ALIVE_EVERY_MS = 4 * 60 * 1000;
    const RECENT_ACTIVITY_MS = 5 * 60 * 1000;
    let lastActivityAt = Date.now();
    let lastKeepAliveAt = Date.now();
    let requestInFlight = false;

    function poaFormIsOpen() {
        return !!document.getElementById('poa-form');
    }

    function keepAliveUrl() {
        const routes = document.getElementById('poa-routes');
        return routes && routes.dataset.keepAliveUrl;
    }

    function csrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta && meta.getAttribute('content');
    }

    function renewSessionIfNeeded(force) {
        const now = Date.now();
        if (!poaFormIsOpen() || document.visibilityState !== 'visible') return;
        if (!force && now - lastActivityAt > RECENT_ACTIVITY_MS) return;
        if (!force && now - lastKeepAliveAt < KEEP_ALIVE_EVERY_MS) return;
        if (requestInFlight || !keepAliveUrl()) return;

        requestInFlight = true;
        fetch(keepAliveUrl(), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'X-CSRF-Token': csrfToken() || '',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            }
        }).then(function(response) {
            if (response.ok) lastKeepAliveAt = Date.now();
        }).catch(function() {
            // Una caída temporal de red no debe interrumpir la edición.
        }).finally(function() {
            requestInFlight = false;
        });
    }

    function registerActivity() {
        lastActivityAt = Date.now();
        renewSessionIfNeeded(false);
    }

    ['keydown', 'input', 'change', 'pointerdown'].forEach(function(eventName) {
        document.addEventListener(eventName, registerActivity, { passive: true });
    });

    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') registerActivity();
    });

    window.setInterval(function() { renewSessionIfNeeded(false); }, KEEP_ALIVE_EVERY_MS);
})();

document.addEventListener("turbolinks:load", function() {
    const url = new URL(window.location.href);
    const completedDraft = url.searchParams.get("import_draft_saved");
    if (completedDraft && /^poa-import:\d+:[0-9a-f-]{36}$/.test(completedDraft)) {
        try { sessionStorage.removeItem(completedDraft); } catch (error) { /* Storage may be unavailable. */ }
        url.searchParams.delete("import_draft_saved");
        window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    }
    var form = document.getElementById('poa-form');
    const productsCacheByIndicator = {}; // indicatorId -> array products
    if (!form) return;
    if (!initImportFormDraft(form, "#mprocess-groups", "el POA")) return;

    function railsFriendlySubmit(formEl) {
        var loading = document.getElementById('loading');
        if (loading) loading.style.display = 'block';

        formEl.submit();
    }

    // Opcional: helper para añadir/quitar el hidden continue_editing
    function submitWith(continueEditing) {
        var existing = form.querySelector('input[name="continue_editing"]');
        if (existing) existing.remove();
        if (continueEditing) {
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'continue_editing';
            hidden.value = '1';
            form.appendChild(hidden);
        }

        railsFriendlySubmit(form);
    }

    function canSubmitForm(formEl) {
        validateAllLengthLimitedFields(formEl);

        if (formEl.checkValidity && !formEl.checkValidity()) {
            markInvalidFields(formEl);
            if (formEl.reportValidity) formEl.reportValidity();
            return false;
        }

        var odsCheckboxes = formEl.querySelectorAll('input[name*="[od_ids]"]:checked');
        if (!odsCheckboxes.length) {
            alert('Selecciona al menos un ODS.');
            return false;
        }

        return true;
    }

    function validateLengthLimitedField(field) {
        if (!field) return true;

        var maximum = parseInt(field.getAttribute('data-max-length') || field.getAttribute('maxlength'), 10);
        if (!maximum) return true;

        var length = (field.value || '').length;
        var wrapper = field.closest('.poa-limited-field');
        var counter = wrapper && wrapper.querySelector('.poa-character-count');
        var counterValue = counter && counter.querySelector('span');
        var isTooLong = length > maximum;

        if (counterValue) counterValue.textContent = length;
        if (counter) {
            counter.classList.toggle('text-danger', isTooLong);
            counter.classList.toggle('text-muted', !isTooLong);
        }

        if (field.setCustomValidity) {
            field.setCustomValidity(isTooLong ? 'El texto supera el máximo de ' + maximum + ' caracteres.' : '');
        }
        if (isTooLong) {
            field.classList.add('is-invalid');
            field.dataset.lengthInvalid = 'true';
        } else if (field.dataset.lengthInvalid === 'true') {
            field.classList.remove('is-invalid');
            delete field.dataset.lengthInvalid;
        }

        return !isTooLong;
    }

    function validateAllLengthLimitedFields(formEl) {
        var valid = true;
        formEl.querySelectorAll('.poa-length-limited').forEach(function(field) {
            if (!validateLengthLimitedField(field)) valid = false;
        });
        return valid;
    }

    form.addEventListener('input', function(event) {
        if (event.target.matches && event.target.matches('.poa-length-limited')) {
            validateLengthLimitedField(event.target);
        }
    });

    validateAllLengthLimitedFields(form);

    function markInvalidFields(formEl) {
        formEl.querySelectorAll('.js-client-invalid-feedback').forEach(function(node) { node.remove(); });
        formEl.querySelectorAll('.is-invalid').forEach(function(field) { field.classList.remove('is-invalid'); });

        var firstInvalid = null;
        Array.prototype.forEach.call(formEl.elements, function(field) {
            if (!field.willValidate || field.checkValidity()) return;

            field.classList.add('is-invalid');
            var feedback = document.createElement('div');
            feedback.className = 'invalid-feedback d-block js-client-invalid-feedback';
            feedback.textContent = field.validationMessage || 'Complete este campo.';
            field.insertAdjacentElement('afterend', feedback);
            if (!firstInvalid && field.offsetParent !== null) firstInvalid = field;
        });

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstInvalid.focus({ preventScroll: true });
        }
    }

    // Click handlers (sin imports)
    var btnSave = document.querySelector('.js-poa-save');
    if (btnSave) {
        btnSave.addEventListener('click', function (e) {
            e.preventDefault();

            if (!canSubmitForm(form)) return;

            lockButtons(this);
            submitWith(false);
        });
    }

    var btnSaveContinue = document.querySelector('.js-poa-save-continue');
    if (btnSaveContinue) {
        btnSaveContinue.addEventListener('click', function (e) {
            e.preventDefault();

            if (!canSubmitForm(form)) return;

            lockButtons(this);
            submitWith(true);
        });
    }

    function lockButtons(clicked) {
        Array.prototype.forEach.call(form.querySelectorAll('button'), function (b) {
            if (!b.getAttribute('data-original-html')) {
                b.setAttribute('data-original-html', b.innerHTML);
            }

            b.disabled = true;
        });

        var html = clicked.getAttribute('data-spinner-html');
        if (html) clicked.innerHTML = html;
    }

    function unlockButtons(formEl) {
        Array.prototype.forEach.call(formEl.querySelectorAll('button'), function (b) {
            b.disabled = false;

            var original = b.getAttribute('data-original-html');
            if (original) {
                b.innerHTML = original;
            }
        });
    }

    // Evita submit con Enter (excepto textarea) y avanza al siguiente campo
    form.addEventListener('keydown', function (e) {
        var t = e.target;
        if ((e.key === 'Enter' || e.keyCode === 13) && t.tagName !== 'TEXTAREA' && t.type !== 'submit') {
            e.preventDefault();
            var fields = Array.prototype.filter.call(
                form.querySelectorAll('input, select, textarea, button'),
                function (el) { return el.offsetParent !== null && !el.disabled && !el.readOnly && el.type !== 'hidden'; }
            );
            var idx = fields.indexOf ? fields.indexOf(t) : fields.findIndex(function(el){ return el === t; });
            if (idx > -1 && idx + 1 < fields.length) fields[idx + 1].focus();
            return false;
        }
    });

    /********************
     * Estado y helpers *
     ********************/
    let cachedMProcesses = [];
    const $macroSelect = $("#poa_macro_process_id");
    const $groupsRoot = $("#mprocess-groups");
    const $addGroupBtn = $("#add-mprocess-group");

    // Rutas desde la vista
    const routesEl = document.getElementById("poa-routes");
    const dependencyFilterUrl      = routesEl && routesEl.dataset.dependencyFilterUrl || null;
    const mprocessByMacroUrl       = routesEl && routesEl.dataset.mprocessByMacroUrl || "/find_by_macro_process";
    const subprocessByMprocessUrl  = routesEl && routesEl.dataset.subprocessByMprocessUrl || "/find_by_mprocess";
    const mprocessBySubprocessUrl  = routesEl && routesEl.dataset.mprocessBySubprocessUrl || "/find_mprocess_by_subprocess";

    // Semilla server-side para usar inmediatamente en el botón
    let initialMProcesses = [];
    try {
        const raw = routesEl && routesEl.dataset.initialMprocesses;
        if (raw) initialMProcesses = JSON.parse(raw) || [];
    } catch (e) { initialMProcesses = []; }

    // Si cached está vacío y tenemos semilla, úsala
    if (cachedMProcesses.length === 0 && initialMProcesses.length > 0) {
        cachedMProcesses = initialMProcesses.slice();
        // habilita el botón "Agregar Proceso" si hay algo para elegir
        $("#add-mprocess-group").prop("disabled", cachedMProcesses.length === 0);
    }

    function setSubprocessOtherRequired($line, isRequired) {
        const $other = $line.find(".sub-process-other");
        if (!$other.length) return;

        const required = !!isRequired;
        $other.prop("required", required);

        // ✅ Validación: solo invalidar si requerido y vacío
        const hasValue = ($other.val() || "").toString().trim().length > 0;

        if ($other[0] && $other[0].setCustomValidity) {
            if (required && !hasValue) {
                $other[0].setCustomValidity("Debes especificar el subproceso cuando seleccionas 'Otro'.");
            } else {
                $other[0].setCustomValidity("");
            }
        }
    }

    function applySubprocessOtherState($line) {
        const id  = ($line.find(".poa-line-sub-process-id").val() || "").toString().trim();
        const txt = ($line.find(".poa-line-sub-process-text").val() || "").toString().trim();

        const $sel   = $line.find(".sub-process-select");
        const $other = $line.find(".sub-process-other");

        if (!id && txt) {
            // "Otro"
            if ($sel.find('option[value="other"]').length === 0) {
                $sel.append(new Option("Otro", "other"));
            }
            $sel.val("other");
            $other.show().val(txt);
            setSubprocessOtherRequired($line, true);
        } else {
            // no es "Otro"
            $other.hide();
            setSubprocessOtherRequired($line, false);
        }
    }

    function bootServerRenderedGroups() {
        $("#mprocess-groups .mprocess-group").each(function() {
            const $group = $(this);

            let mid = ($group.attr("data-mprocess-id") || "").toString().trim();
            if (!mid) {
                mid = ($group.find(".mprocess-select").val() || "").toString().trim();
                if (mid) $group.attr("data-mprocess-id", mid);
            }

            $group.find(".add-line-under-mprocess").prop("disabled", !mid);

            $group.find(".poa-lines-under-mprocess .poa-line").each(function() {
                const $line = $(this);

                // Siempre sincronizar hidden mprocess_id con el grupo
                $line.find(".poa-line-mprocess-id").val(mid || "");

                // Estado inicial "Otro" (si corresponde) en EDIT
                applySubprocessOtherState($line);

                // Si no hay opciones (o solo prompt+otro), repoblar desde backend
                const $sub = $line.find(".sub-process-select");
                const selectedId =
                    ($line.find(".poa-line-sub-process-id").val() || "").toString().trim();

                const hasEnoughOptions = $sub.find("option").length > 2; // prompt + algo
                if (mid && !hasEnoughOptions) {
                    ensureSubprocessOptionsForLine($line, mid, selectedId);
                }
            });
        });
    }

    // Llamada de boot al cargar
    bootServerRenderedGroups();

    function cloneTemplateContent(tplId) {
        const tpl = document.getElementById(tplId);
        if (!tpl) return null;
        const newIndex = Date.now();

        // clonamos el template y conservamos el nodo raíz (NO el innerHTML)
        const frag = tpl.content.cloneNode(true);
        const root = frag.firstElementChild; // .mprocess-group o .poa-line

        // reemplazamos NEW_RECORD en el árbol usando outerHTML
        const tmp = document.createElement("div");
        tmp.innerHTML = root.outerHTML.replace(/NEW_RECORD/g, newIndex);

        // devolvemos el elemento raíz real (no un wrapper)
        return tmp.firstElementChild;
    }

    function fetchMProcessesForCurrentMacro() {
        const macroId = $macroSelect.val();
        cachedMProcesses = [];
        if (!macroId) {
            $addGroupBtn.prop("disabled", true);
            return Promise.resolve([]);
        }
        return $.getJSON(mprocessByMacroUrl, { macro_process_id: macroId })
            .then(function(data){
                cachedMProcesses = data || [];
                $addGroupBtn.prop("disabled", cachedMProcesses.length === 0);
                return cachedMProcesses;
            });
    }

    function createEmptyGroup() {
        const groupEl = cloneTemplateContent("mprocess-group-template");
        if (!groupEl) return null;

        const $group  = $(groupEl);
        const $select = $group.find(".mprocess-select");

        // Si tenés cache, repuebla; si no, usa lo que vino del server
        if (cachedMProcesses.length > 0) {
            const selectedNow = $select.val();
            $select.empty().append('<option value="">Selecciona un proceso</option>');
            cachedMProcesses.forEach(mp => $select.append(new Option(mp.name, mp.id)));
            if (selectedNow) $select.val(selectedNow);
        }

        $groupsRoot.append(groupEl);

        // deshabilitado hasta que elijan proceso
        $group.find(".add-line-under-mprocess").prop("disabled", true);

        return $group;
    }

    function populateAllGroupSelects() {
        // Rellena cada .mprocess-select con cachedMProcesses conservando el valor seleccionado
        $groupsRoot.find(".mprocess-group").each(function() {
            const $group = $(this);
            const $select = $group.find(".mprocess-select");
            const selected = $group.attr("data-mprocess-id") || $select.val() || "";
            const selectedLabel = selected ? $select.find('option[value="' + selected + '"]').text() : '';

            $select.empty().append('<option value="">Selecciona un proceso</option>');
            cachedMProcesses.forEach(function(mp) {
                $select.append(new Option(mp.name, mp.id));
            });

            if (selected) {
                if ($select.find('option[value="' + selected + '"]').length === 0) {
                    $select.append(new Option(selectedLabel || 'Proceso guardado', selected));
                }
                $select.val(String(selected));
                $group.find(".add-line-under-mprocess").prop("disabled", false);
            }
        });
    }

    function ensureSubprocessOptionsForLine($line, mprocessId, selectedSubprocessId) {
        const $subSelect = $line.find(".sub-process-select");
        const $sid  = $line.find(".poa-line-sub-process-id");
        const $stxt = $line.find(".poa-line-sub-process-text");

        const currentId  = (selectedSubprocessId || $sid.val() || "").toString().trim();
        const currentTxt = ($stxt.val() || "").toString().trim();

        $subSelect.empty().append('<option value="">Selecciona un subproceso</option>');

        if (!mprocessId) {
            $subSelect.append(new Option("Otro", "other"));

            if (!currentId && currentTxt) {
                $subSelect.val("other");
            } else {
                $subSelect.val("");
            }

            $subSelect.trigger("change"); // ✅ sincroniza hidden + required + show/hide
            return Promise.resolve();
        }

        return $.getJSON(subprocessByMprocessUrl, { mprocess_id: mprocessId })
            .then(function(list){
                (list || []).forEach(function(sp){
                    $subSelect.append(new Option(sp.name, sp.id));
                });

                $subSelect.append(new Option("Otro", "other"));

                // 1) Si hay ID válido en la lista, seleccionarlo
                if (currentId && $subSelect.find('option[value="'+currentId+'"]').length > 0) {
                    $subSelect.val(String(currentId));
                }
                // 2) Si no hay ID pero sí texto => Otro
                else if (!currentId && currentTxt) {
                    $subSelect.val("other");
                }
                // 3) sino vacío
                else {
                    $subSelect.val("");
                }

                // Disparar change para que sincronice hidden + required
                $subSelect.trigger("change");
            });
    }

    /*************************************************
     * Eliminar línea (delegación por clase)         *
     *************************************************/
    // helper: contenedor oculto para líneas marcadas a borrar (para que se envíen)
    function ensureRemovedHolder() {
        let holder = document.getElementById("poa-removed-lines-holder");
        if (!holder) {
            holder = document.createElement("div");
            holder.id = "poa-removed-lines-holder";
            holder.style.display = "none";
            // meterlo dentro del formulario para que se envíe
            const form = document.querySelector("form");
            (form || document.body).appendChild(holder);
        }
        return $(holder);
    }

    // helper: ¿tiene id persistido?
    function lineHasPersistedId($line) {
        const $id = $line.find('input[name*="[id]"]');
        return $id.length && $id.val() && $id.val().trim() !== "";
    }

    // helper: marcar una línea para destruir (persistida) o quitar si es nueva
    function markOrRemoveLine($line) {
        const $destroy = $line.find('input.destroy-field, input[name*="[_destroy]"]');
        if (!lineHasPersistedId($line)) {
            // Nueva: se puede quitar del DOM
            $line.remove();
            return;
        }

        // Persistida: marcar _destroy=1, deshabilitar el resto de campos,
        // pero mantener habilitados "id" y "_destroy"
        if ($destroy.length) $destroy.val("1");

        $line.find('input, select, textarea').each(function() {
            const name = $(this).attr("name") || "";
            const keep = name.endsWith("[id]") || name.endsWith("[_destroy]");
            if (!keep) $(this).prop("disabled", true);
            else $(this).prop("disabled", false);
        });

        // Ocultar visualmente y mover al holder para que se envíe
        const $holder = ensureRemovedHolder();
        $line.hide().appendTo($holder);
    }

    /*************************************************
     * Botón: Eliminar Línea                         *
     *************************************************/
    $(document).off("click.removeLine", ".remove-poa-line");
    $(document).on("click.removeLine", ".remove-poa-line", function () {
        const $line = $(this).closest(".poa-line");
        // limpiar estados de error y UI
        $line.find('.field_with_errors').removeClass('field_with_errors');
        $line.find('.invalid-feedback').remove();

        markOrRemoveLine($line);
    });

    $(document).off("click.indicatorInstructions", ".show-indicator-instructions");
    $(document).on("click.indicatorInstructions", ".show-indicator-instructions", function() {
        const $row = $(this).closest('.poa-line');
        const instructions = ($row.find('.indicator-info').text() || '').trim();
        const $modalText = $('#indicatorInstructionsModal .indicator-instructions-modal-text');

        if (instructions) {
            $modalText.text(instructions).removeClass('text-muted fst-italic');
        } else {
            $modalText.text('No se han cargado instrucciones para este indicador.')
                .addClass('text-muted fst-italic');
        }
    });

    /***********************************************
     * Botón: Quitar Proceso (elimina TODAS líneas) *
     ***********************************************/
    $(document).off("click.removeGroup", ".remove-mprocess-group");
    $(document).on("click.removeGroup", ".remove-mprocess-group", function () {
        const $group = $(this).closest(".mprocess-group");
        const $lines = $group.find(".poa-lines-under-mprocess .poa-line");

        $lines.each(function() {
            markOrRemoveLine($(this));
        });

        // quitar el grupo visualmente
        $group.remove();
    });

    /*************************************************************
     * Faculty + Filial ⇒ Dependencias + MacroProcesses          *
     *************************************************************/
    $(".filter-dependency").on("change", function() {
        let faculty_id = $("#poa_faculty_id").val();
        let filial_id  = $("#poa_filial_id").val();
        let poa_year  = $("#poa_year").val();

        if (faculty_id && filial_id && dependencyFilterUrl) {
            $.ajax({
                url: dependencyFilterUrl,
                method: "GET",
                data: { faculty_id: faculty_id, filial_id: filial_id, year: poa_year },
                dataType: "json",
                success: function(data) {
                    // Dependencias
                    let dependencySelect = $("#dependency-select");
                    dependencySelect.empty().append('<option value="">Selecciona una dependencia</option>');
                    (data.dependencies || []).forEach(function(dependency) {
                        dependencySelect.append(new Option(dependency.name, dependency.id));
                    });

                    // MacroProcesses
                    let macroSelect = $("#poa_macro_process_id");
                    macroSelect.empty().append('<option value="">Selecciona un macro proceso</option>');
                    (data.macro_processes || []).forEach(function(macro) {
                        macroSelect.append(new Option(macro.name, macro.id));
                    });

                }
            });
        }
    });

    /*********************************************
     * MacroProcess ⇒ (re)cargar MProcesses      *
     *********************************************/
    $macroSelect.off("change.macro");
    $macroSelect.on("change.macro", function () {
        fetchMProcessesForCurrentMacro()
            .then(function () {
                refreshAllGroupsForNewMacro();
            })
            .catch(function (err) {
                console.error("No se pudieron cargar MProcesses:", err);
            });
    });

    // crea <option> seguro
    function opt(text, val) { return $('<option>').val(String(val)).text(text); }

    // repuebla un <select> de procesos conservando el seleccionado
    function repopulateMprocessSelect($select) {
        const prev = ($select.val() || "").toString();
        const prevText = $select.find('option:selected').text();

        $select.empty().append(opt('Selecciona un proceso', ''));

        // opciones del macro actual
        (cachedMProcesses || []).forEach(function (mp) {
            $select.append(opt(mp.name, mp.id));
        });

        // si el valor anterior existe en el nuevo macro, lo seleccionamos
        if (prev && $select.find('option[value="'+prev+'"]').length > 0) {
            $select.val(prev);
            return { kept: true, prev, prevText };
        }

        // si NO existe en el macro actual, preservamos la selección anterior
        // agregándola como opción al final (marcada)
        if (prev) {
            $select.append(
                opt(prevText + " (fuera del macro actual)", prev).attr('data-outside-macro', '1')
            );
            $select.val(prev);
            return { kept: false, prev, prevText };
        }

        return { kept: true, prev: "", prevText: "" };
    }

    // actualiza TODOS los grupos después de cambiar el macro, sin borrar nada
    function refreshAllGroupsForNewMacro() {
        const tasks = [];

        $groupsRoot.find(".mprocess-group").each(function () {
            const $group  = $(this);
            const $mpsel  = $group.find(".mprocess-select");

            // 1) repoblar select de proceso
            const rep = repopulateMprocessSelect($mpsel);
            const selectedMprocessId = ($mpsel.val() || "").toString().trim();

            // 2) habilitar/deshabilitar botón de "Agregar Producto"
            $group.find(".add-line-under-mprocess").prop("disabled", !selectedMprocessId);

            // 3) para cada línea del grupo, repoblar subprocesos conservando selección
            $group.find(".poa-lines-under-mprocess .poa-line").each(function () {
                const $line = $(this);
                // asegura el hidden con mprocess_id
                $line.find(".poa-line-mprocess-id").val(selectedMprocessId || "");

                const selectedSubprocessId = ($line.find(".poa-line-sub-process-id").val() || "").toString().trim();
                tasks.push(
                    ensureSubprocessOptionsForLine($line, selectedMprocessId, selectedSubprocessId)
                );
            });
        });

        return Promise.all(tasks);
    }

    fetchMProcessesForCurrentMacro()
        .then(function() {
            populateAllGroupSelects();
            // ✅ solo refrescar si realmente hay macro seleccionado
            if (($macroSelect.val() || "").toString().trim()) {
                return refreshAllGroupsForNewMacro();
            }
        })
        .catch(function(err){
            console.error("No se pudieron cargar MProcesses:", err);
        });

    $(document).off("change.poaSubprocessSelect", ".sub-process-select");
    $(document).on("change.poaSubprocessSelect", ".sub-process-select", function() {
        const $row   = $(this).closest('.poa-line');
        const $other = $row.find('.sub-process-other');
        const $sid   = $row.find('.poa-line-sub-process-id');
        const $stxt  = $row.find('.poa-line-sub-process-text');

        const val = ($(this).val() || '').toString().trim();

        if (val === 'other') {
            $sid.val('');
            $other.show().focus();

            // mantener texto previo si existe
            $stxt.val(($other.val() || $stxt.val() || '').toString());

            setSubprocessOtherRequired($row, true);
            return;
        }

        if (!val) {
            $sid.val('');
            $stxt.val('');
            $other.hide().val('');
            setSubprocessOtherRequired($row, false);
            return;
        }

        // subproceso real
        $sid.val(val);
        $stxt.val('');
        $other.hide().val('');
        setSubprocessOtherRequired($row, false);
    });

    $(document).off("input.poaSubprocessOther", ".sub-process-other");
    $(document).on("input.poaSubprocessOther", ".sub-process-other", function() {
        const $row = $(this).closest('.poa-line');
        $row.find('.poa-line-sub-process-id').val('');
        $row.find('.poa-line-sub-process-text').val(($(this).val() || '').toString());
        setSubprocessOtherRequired($row, true);
    });

    /***************************************
     * Agregar / quitar grupo de proceso   *
     ***************************************/
    $(document).off("click.addGroup", "#add-mprocess-group");

    $(document).on("click.addGroup", "#add-mprocess-group", function () {
        createEmptyGroup();

        const $submit = $("#submit-poa");
        if ($submit.length) {
            $("html, body").animate(
                { scrollTop: Math.max(0, $submit.offset().top - 100) },
                400
            );
        }
    });

    $(document).off("change.mprocSel", ".mprocess-select");
    $(document).on("change.mprocSel", ".mprocess-select", function () {
        const $group = $(this).closest(".mprocess-group");
        const newMprocessId = ($(this).val() || "").toString().trim();

        $group.attr("data-mprocess-id", newMprocessId);
        $group.data("mprocessId", newMprocessId);
        $group.find(".add-line-under-mprocess").prop("disabled", !newMprocessId);

        const $lines = $group.find(".poa-lines-under-mprocess .poa-line");

        if (!newMprocessId) {
            $lines.each(function () {
                const $line = $(this);

                $line.find(".poa-line-mprocess-id").val("");
                $line.find(".sub-process-select")
                    .empty()
                    .append('<option value="">Selecciona un subproceso</option>')
                    .val("");

                // ✅ limpiar estado "Otro"
                $line.find(".poa-line-sub-process-id").val("");
                $line.find(".poa-line-sub-process-text").val("");
                $line.find(".sub-process-other").hide().val("");
                setSubprocessOtherRequired($line, false);
            });
            return;
        }

        // Reasocia y repuebla subprocesos en las líneas existentes de ESTE grupo
        $lines.each(function () {
            const $line = $(this);

            $line.find(".poa-line-mprocess-id").val(newMprocessId);

            // ✅ limpiar selección previa para evitar valores inválidos
            $line.find(".poa-line-sub-process-id").val("");
            $line.find(".poa-line-sub-process-text").val("");
            $line.find(".sub-process-other").hide().val("");
            setSubprocessOtherRequired($line, false);

            // ✅ recargar opciones de subproceso para el nuevo proceso
            ensureSubprocessOptionsForLine($line, newMprocessId, null);
        });
    });

    /********************************************
     * Agregar una línea bajo un grupo          *
     ********************************************/
    // Helper para resolver (y persistir) el mprocess_id del grupo
    function resolveGroupMprocessId($group) {
        // primero intenta data()
        let id = ($group.data('mprocessId') || '').toString().trim();
        if (!id) {
            // luego intenta atributo
            id = ($group.attr('data-mprocess-id') || '').toString().trim();
        }
        if (!id) {
            // finalmente, leer del select
            id = ($group.find('.mprocess-select').val() ||
                $group.find('.mprocess-select option:selected').val() ||
                '').toString().trim();
            if (id) {
                $group.attr('data-mprocess-id', id);
                $group.data('mprocessId', id);
                // aseguramos que el botón quede habilitado
                $group.find(".add-line-under-mprocess").prop("disabled", false);
            }
        }
        return id;
    }

    // antes de registrar, limpia handlers previos en esta página (turbolinks)
    $(document).off('click.addLine');
    $(document).on('click.addLine', '.add-line-under-mprocess', function () {
        const $group = $(this).closest(".mprocess-group");

        // Obtener mprocess_id del select o de los data-attributes
        const $sel = $group.find("select.mprocess-select").first();
        let mprocessId = ($sel.length ? ($sel.val() || $sel.find("option:selected").val() || "") : "").toString().trim();

        if (!mprocessId) {
            mprocessId = ($group.attr("data-mprocess-id") || $group.data("mprocessId") || "").toString().trim();
        }

        if (!mprocessId) {
            alert("Primero selecciona un proceso.");
            return;
        }

        // Persistir el mprocess en data-* para usos futuros
        $group.attr("data-mprocess-id", mprocessId);
        $group.data("mprocessId", mprocessId);
        $group.find(".add-line-under-mprocess").prop("disabled", false);

        // Crear la nueva línea desde el template
        const lineEl = cloneTemplateContent("poa-line-template-for-group");
        if (!lineEl) return;

        const $line = $(lineEl);

        // Setear mprocess oculto y preparar select de subproceso
        $line.find(".poa-line-mprocess-id").val(mprocessId);
        const $sub = $line.find(".sub-process-select");
        $sub.empty().append('<option value="">Selecciona un subproceso</option>');

        // Agregar al DOM
        $group.find(".poa-lines-under-mprocess").append($line);

        // Poblar subprocesos
        ensureSubprocessOptionsForLine($line, mprocessId);
        setSubprocessOtherRequired($line, false);
        $line.find(".sub-process-other").hide().val("");
        $line.find(".poa-line-sub-process-id").val("");
        $line.find(".poa-line-sub-process-text").val("");

        // 👉 Scroll suave hacia la nueva línea
        if ($line.offset()) {
            $('html, body').animate(
                { scrollTop: $line.offset().top - 100 }, // margen arriba
                400
            );
        }

        // 👉 Opcional: enfocar el primer campo del nuevo producto
        const $firstField = $line.find('input, select, textarea')
            .filter(':visible:enabled')
            .first();
        if ($firstField.length) {
            $firstField.focus();
        }
    });

    /***********************************************
     * Matriz ⇒ Acciones ⇒ Indicadores              *
     ***********************************************/
    $(document).off("change.matrix", ".poa-line-matrix-select");
    $(document).on("change.matrix", ".poa-line-matrix-select", function() {
        let matrixId = $(this).val();
        let $row = $(this).closest('.poa-line');
        let $action = $row.find('.poa-line-action-line-select');
        let $indicator = $row.find('.indicator-select');
        $action.empty().append('<option value="">Selecciona una acción</option>');
        $indicator.empty().append('<option value="">Selecciona un indicador</option>');

        if (matrixId) {
            $.getJSON("/find_by_matrix", { matrix_id: matrixId }, function(data){
                (data || []).forEach(function(al) {
                    $action.append(`<option value="${al.id}">${al.action_line}</option>`);
                });
                $row.find('.poa-line-baseline').val("");
                $row.find('.poa-line-meta').val("");
                $row.find('.poa-line-amount_p1, .poa-line-amount_p2, .poa-line-amount_p3, .poa-line-amount_p4').val("");
            });
        }
    });

    $(document).off("change.actionLine", ".poa-line-action-line-select");
    $(document).on("change.actionLine", ".poa-line-action-line-select", function() {
        let actionLineId = $(this).val();
        let $row = $(this).closest('.poa-line');
        let $indicator = $row.find('.indicator-select');
        $row.find(".poa-line-indicator-id").val('');
        $row.find(".poa-line-indicator-text").val('');
        hideIndicatorOther($row.find(".indicator-other").val(''));
        setIndicatorOtherRequired($row, false);
        $indicator.empty().append('<option value="">Selecciona un indicador</option>');

        if (actionLineId) {
            $.getJSON("/find_by_line", { action_line_id: actionLineId }, function(data){
                (data || []).forEach(function(ind) {
                    $indicator.append(`<option value="${ind.id}">${ind.indicator}</option>`);
                });
                $row.find('.poa-line-baseline').val("");
                $row.find('.poa-line-meta').val("");
                $row.find('.poa-line-amount_p1, .poa-line-amount_p2, .poa-line-amount_p3, .poa-line-amount_p4').val("");
            });
        }

        $indicator.append('<option value="other">Otro</option>');
        applyIndicatorOtherState($row);
    });

    /***************************************
     * Indicador ⇒ baseline/meta + periodos *
     ***************************************/
    $(document).off("change.indicator", ".indicator-select");
    $(document).on("change.indicator", ".indicator-select", function() {
        let $row = $(this).closest('.poa-line');
        let poaYear = $('#poa_year').val();

        const val = ($(this).val() || '').toString().trim();
        const $hidId  = $row.find(".poa-line-indicator-id");
        const $hidTxt = $row.find(".poa-line-indicator-text");
        const $other  = $row.find(".indicator-other");

        if (val === 'other') {
            $hidId.val('');
            showIndicatorOther($other);
            $other.focus();
            $hidTxt.val(($other.val() || $hidTxt.val() || '').toString());

            setIndicatorOtherRequired($row, true);

            // ✅ permitir meta manual
            $row.find('[name*="[meta]"]').prop('readonly', false).val('');
            // default anual: habilitar solo P1 y limpiar P2..P4
            $row.find('[name*="[amount_p1]"]').prop('disabled', false).prop('required', true).val('');
            $row.find('[name*="[amount_p2]"],[name*="[amount_p3]"],[name*="[amount_p4]"]').prop('disabled', true).prop('required', false).val('');

            // reset productos (sin indicador real no hay products)
            resetProductControls($row);

            // limpiar info del indicador
            $row.find('.indicator-info').text('');
            $row.find('.poa_line_indicator_unit').val('1');
            $row.find('.col-md-6.amount').hide();
            $row.find('input[name*="[item_base]"], input[name*="[item_obtained]"]').prop('required', false).val('');
            $row.find('input[name*="[baseline]"]').prop('readonly', false);

            return;
        }

        if (!val) {
            $hidId.val('');
            $hidTxt.val('');
            hideIndicatorOther($other.val(''));
            setIndicatorOtherRequired($row, false);
            resetProductControls($row);
            return;
        }

        // ✅ indicador real
        $hidId.val(val);
        $hidTxt.val('');
        hideIndicatorOther($other.val(''));
        setIndicatorOtherRequired($row, false);

        // meta vuelve a readonly (la trae el backend)
        $row.find('[name*="[meta]"]').prop('readonly', true);

        actualizarPoaLine($row, poaYear);
    });

    $(document).off("input.poaIndicatorOther", ".indicator-other");
    $(document).on("input.poaIndicatorOther", ".indicator-other", function() {
        const $row = $(this).closest('.poa-line');
        $row.find('.poa-line-indicator-id').val('');
        $row.find('.poa-line-indicator-text').val(($(this).val() || '').toString());
        setIndicatorOtherRequired($row, true);
    });

    function actualizarPoaLine($row, poaYear, opts) {
        opts = opts || {};
        let indicatorId = ($row.find('.poa-line-indicator-id').val() || '').toString().trim();
        if (!indicatorId) return;

        $.ajax({
            url: `/indicators/${indicatorId}/get_for_poa_line`,
            method: 'GET',
            data: { year: poaYear },
            dataType: 'json',
            success: function (data) {
                if (!opts.onlyProducts) {
                    $row.find('input[name*="[baseline]"]').val(data.baseline);
                    $row.find('input[name*="[meta]"]').val(data.meta.toFixed(2));
                    $row.find('input[name*="[meta]"]').attr('max', data.measurement_unit === 2 ? 100 : null);
                    const description = $('<div>').html(data.description || '').text();
                    $row.find('.indicator-info').text(description);
                    $row.find('.poa_line_indicator_unit').val(data.measurement_unit);

                    let itemBaseInput = $row.find('input[name*="[item_base]"]');
                    let itemObtainedInput = $row.find('input[name*="[item_obtained]"]');
                    let baselineInput = $row.find('input[name*="[baseline]"]');

                    if (data.measurement_unit !== 1) {
                        $row.find('.col-md-6.amount').show();
                        itemBaseInput.prop('required', true);
                        itemObtainedInput.prop('required', true);
                        baselineInput.prop('readonly', true);

                        let base_name = data.item_base_name;
                        let obtained_name = data.item_obtained_name;
                        let current_year = new Date().getFullYear();
                        if (Number(data.number) !== 1) {
                            base_name += "[" + (current_year - (data.measurement_unit === 3 ? 2 : 1)) + "]";
                        }
                        obtained_name += "[" + (current_year - 1) + "]";
                        $row.find('.amount:first label').text(base_name);
                        $row.find('.amount:last label').text(obtained_name);
                    } else {
                        $row.find('.col-md-6.amount').hide();
                        itemBaseInput.prop('required', false).val('');
                        itemObtainedInput.prop('required', false).val('');
                        baselineInput.prop('readonly', false);
                    }

                    let amountFields = [
                        $row.find('input[name*="[amount_p1]"]'),
                        $row.find('input[name*="[amount_p2]"]'),
                        $row.find('input[name*="[amount_p3]"]'),
                        $row.find('input[name*="[amount_p4]"]')
                    ];
                    amountFields.forEach(f => f.prop('disabled', true).prop('required', false).val(''));

                    let enabled = 1;
                    const freq = data.frequency;
                    if (freq.includes("Trimestral")) enabled = 4;
                    else if (freq.includes("Cuatrimestral")) enabled = 3;
                    else if (freq.includes("Semestral")) enabled = 2;

                    for (let i = 0; i < enabled; i++) {
                        amountFields[i].prop('disabled', false).prop('required', true);
                    }
                }

                // ✅ Products en la MISMA respuesta
                const list = (data && data.products) ? data.products : [];
                productsCacheByIndicator[String(indicatorId)] = list;
                populateProductsSelect($row, list);
            }
        });
    }

    function setProductRequiredState($line) {
        const $select = $line.find(".poa-line-product-select");
        const $other  = $line.find(".poa-line-product-other");
        const $pid    = $line.find(".poa-line-product-id");
        const $text   = $line.find(".poa-line-product-hidden");

        if (!$select.length) return;

        const productId = ($pid.val() || "").toString().trim();
        const productText = ($text.val() || "").toString().trim();

        if ($select[0] && $select[0].setCustomValidity) {
            if (!productId && !productText) {
                $select[0].setCustomValidity("Selecciona un producto o especifica otro.");
            } else {
                $select[0].setCustomValidity("");
            }
        }

        if ($other[0] && $other[0].setCustomValidity) {
            const isOther = ($select.val() || "").toString().trim() === "other";

            if (isOther && !productText) {
                $other[0].setCustomValidity("Debes especificar el producto cuando seleccionas 'Otro'.");
            } else {
                $other[0].setCustomValidity("");
            }
        }
    }

    function resetProductControls($row) {
        const $sel   = $row.find('.poa-line-product-select');
        const $other = $row.find('.poa-line-product-other');
        const $hid   = $row.find('.poa-line-product-hidden');

        if ($sel.length) {
            $sel.empty().append('<option value="">Selecciona un producto</option>');
            $sel.append('<option value="other">Otro</option>');
        }
        $other.hide().val('');
        $hid.val('');
    }

    function setField($el, val, overwrite) {
        if (!$el || !$el.length) return;
        const current = ($el.val() || '').toString().trim();
        const incoming = (val || '').toString();
        if (!incoming) return;

        if (overwrite || current === '') $el.val(incoming);
    }

    function applyProductTemplateToRow($row, p, overwrite) {
        if (!p) return;

        // product string que se guarda
        setField($row.find('.poa-line-product-hidden'), p.product, true);

        // campos a completar
        setField($row.find('.poa-line-generic-activity'),     p.generic_activity, overwrite);
        setField($row.find('.poa-line-verification-methods'), p.medios_verificacion, overwrite);
        setField($row.find('.poa-line-resources-human'),      p.recursos_humanos, overwrite);
        setField($row.find('.poa-line-resources-physical'),   p.recursos_materiales, overwrite);
    }

    function populateProductsSelect($row, productsList) {
        const $sel   = $row.find('.poa-line-product-select');
        const $other = $row.find('.poa-line-product-other');
        const $hid   = $row.find('.poa-line-product-hidden'); // texto (para "Otro" o legacy)
        const $pid   = $row.find('.poa-line-product-id');     // relación product_id

        if (!$sel.length) return;

        // 0) Qué había previamente en esta fila (EDIT)
        const currentProductId =
            ($pid.val() || $sel.data('currentProductId') || '').toString().trim();

        const currentProductText =
            ($hid.val() || $sel.data('currentProduct') || '').toString().trim();

        // 1) Repoblar opciones
        $sel.empty().append('<option value="">Selecciona un producto</option>');
        (productsList || []).forEach(function(p){
            const label = p.is_final ? `${p.product} (Producto Final)` : p.product;
            $sel.append($('<option>', { value: String(p.id), text: label }));
        });
        $sel.append('<option value="other">Otro</option>');

        // 2) Si hay product_id y existe en la lista, se selecciona por ID
        if (currentProductId && $sel.find('option[value="' + currentProductId + '"]').length > 0) {
            $sel.val(currentProductId);
            $other.hide().val('');

            // asegurar consistencia: product_id seteado, texto opcional
            $pid.val(currentProductId);

            // opcional: mantener el texto sincronizado al nombre del producto
            const picked = (productsList || []).find(p => String(p.id) === String(currentProductId));
            if (picked) {
                $hid.val(picked.product || '');
                // Al cargar el formulario, conservar incluso los campos vacíos.
            }
            setProductRequiredState($row);
            return;
        }

        // 3) Si NO hay product_id pero hay texto, interpretamos como "Otro"
        if (currentProductText) {
            $sel.val('other');
            $other.show().val(currentProductText);
            $pid.val('');
            $hid.val(currentProductText);
            return;
        }

        // 4) Ninguno
        $sel.val('');
        $other.hide().val('');
        $pid.val('');
        $hid.val('');

        setProductRequiredState($row);
    }

    function confirmProductReplacement(onConfirm) {
        const element = document.createElement('div');
        element.className = 'modal fade';
        element.tabIndex = -1;
        element.setAttribute('aria-labelledby', 'poa-product-confirm-title');
        element.innerHTML = `
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="poa-product-confirm-title">Reemplazar valores del producto</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                    </div>
                    <div class="modal-body">
                        <p>¿Quieres reemplazar la actividad genérica, los medios de verificación y los recursos humanos y materiales por los valores del producto seleccionado?</p>
                        <p class="mb-0">Si eliges No, se conservarán los valores actuales y el producto quedará seleccionado.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No, conservar valores</button>
                        <button type="button" class="btn btn-primary skip-loading" data-confirm-replacement>Sí, reemplazar</button>
                    </div>
                </div>
            </div>`;
        document.body.appendChild(element);
        const modal = new Modal(element);
        element.querySelector('[data-confirm-replacement]').addEventListener('click', function() {
            onConfirm();
            modal.hide();
        });
        element.addEventListener('hidden.bs.modal', function() {
            modal.dispose();
            element.remove();
        }, { once: true });
        modal.show();
    }

    $(document).off("change.poaProductSelect", ".poa-line-product-select");
    $(document).on("change.poaProductSelect", ".poa-line-product-select", function() {
        const $row   = $(this).closest('.poa-line');
        const $other = $row.find('.poa-line-product-other');
        const $hid   = $row.find('.poa-line-product-hidden');
        const $pid   = $row.find('.poa-line-product-id');

        const selectedVal = ($(this).val() || '').toString().trim();

        if (selectedVal === 'other') {
            $pid.val('');
            $other.show().focus();
            $hid.val(($other.val() || $hid.val() || '').toString());
            setProductRequiredState($row);
            return;
        }

        if (!selectedVal) {
            $pid.val('');
            $hid.val('');
            $other.hide().val('');
            setProductRequiredState($row);
            return;
        }

        $pid.val(selectedVal);
        $other.hide().val('');

        const indicatorId = ($row.find('.indicator-select').val() || '').toString().trim();
        const list = productsCacheByIndicator[indicatorId] || [];
        const picked = list.find(p => String(p.id) === String(selectedVal));

        if (picked) {
            $hid.val(picked.product || '');
            confirmProductReplacement(function() {
                if ($row.find('.poa-line-product-select').val() === selectedVal) {
                    applyProductTemplateToRow($row, picked, true);
                }
            });
        }

        setProductRequiredState($row);
    });

    $(document).off("input.poaProductOther", ".poa-line-product-other");
    $(document).on("input.poaProductOther", ".poa-line-product-other", function() {
        const $row = $(this).closest('.poa-line');

        $row.find('.poa-line-product-id').val('');
        $row.find('.poa-line-product-hidden').val($(this).val());

        setProductRequiredState($row);
    });

    function fetchProductsForIndicator(indicatorId, poaYear) {
        const key = String(indicatorId || "").trim();
        if (!key) return $.Deferred().resolve([]).promise();

        // ✅ cache
        if (productsCacheByIndicator[key]) {
            return $.Deferred().resolve(productsCacheByIndicator[key]).promise();
        }

        // ✅ 1 sola llamada por indicador (y guardamos en cache)
        return $.getJSON(`/indicators/${key}/get_for_poa_line`, { year: poaYear })
            .then(function (data) {
                const list = (data && data.products) ? data.products : [];
                productsCacheByIndicator[key] = list;
                return list;
            })
            .catch(function () {
                productsCacheByIndicator[key] = [];
                return [];
            });
    }

    function initProductsForAllLines() {
        const poaYear = ($('#poa_year').val() || '').toString().trim();
        const rowsByIndicator = {};

        $('.poa-line').each(function () {
            const $row = $(this);

            const destroyVal = ($row.find('input.destroy-field, input[name*="[_destroy]"]').val() || '').toString();
            if (destroyVal === "1") return;

            // ✅ 1) Forzar estado inicial (EDIT) sin esperar AJAX
            if ($row.find('.poa-line-product-select').length > 0) {
                populateProductsSelect($row, []);   // <-- esto es lo clave
            }

            const indicatorId = ($row.find('.indicator-select').val() || '').toString().trim();
            if (!indicatorId) return;

            if ($row.find('.poa-line-product-select').length === 0) return;

            rowsByIndicator[indicatorId] = rowsByIndicator[indicatorId] || [];
            rowsByIndicator[indicatorId].push($row);
        });

        // ✅ 2) Luego sí: cargar lista real y repoblar
        Object.keys(rowsByIndicator).forEach(function(indicatorId) {
            fetchProductsForIndicator(indicatorId, poaYear).then(function(list) {
                (rowsByIndicator[indicatorId] || []).forEach(function($row){
                    populateProductsSelect($row, list);
                });
            });
        });
    }

    initProductsForAllLines();

    /*******************************
     * Cálculo baseline y updateMeta
     *******************************/
    function updateBaseline($row) {
        let measurementUnit = parseInt($row.find('.poa_line_indicator_unit').val());
        let itemBase = parseFloat($row.find('input[name*="[item_base]"]').val());
        let itemObtained = parseFloat($row.find('input[name*="[item_obtained]"]').val());
        let baselineInput = $row.find('input[name*="[baseline]"]');

        let calculated = 0;
        if (!isNaN(itemBase) && !isNaN(itemObtained)) {
            switch (measurementUnit) {
                case 3:
                    calculated = (itemBase === 0) ? itemObtained : (((itemObtained / itemBase) - 1) * 100).toFixed(2);
                    break;
                case 2:
                    calculated = (itemBase === 0) ? ((itemObtained === 0) ? 0 : 100) : (itemObtained * 100 / itemBase).toFixed(2);
                    break;
                default:
                    calculated = itemObtained.toFixed(2);
                    break;
            }
            baselineInput.val(calculated);
            updateMeta(calculated, $row);
        } else {
            baselineInput.val('');
        }
    }

    $(document).on('change', 'input[name*="[item_base]"], input[name*="[item_obtained]"]', function() {
        updateBaseline($(this).closest('.poa-line'));
    });

    $(document).on('change', '#poa_year', function () {
        let poaYear = $(this).val();
        $('.poa-line').each(function () { actualizarPoaLine($(this), poaYear); });
    });

    $(document).on('input', '#poa_email, [name*="email"]', function () {
        let email = $(this).val();
        let emailRegex = /^[a-zA-Z0-9._+-]+@(uni|fiuni|facea.uni|postgrado.uni|facyt.uni|cyt.uni|humanidades.uni|medicina.uni|facaf.uni|derecho.uni)\.edu\.py$/i;
        let $emailError = $('#email-error');
        if (email && !emailRegex.test(email)) {
            if ($emailError.length === 0) $(this).after('<div id="email-error" style="color: red;">Formato de correo electrónico inválido</div>');
        } else {
            $emailError.remove();
        }
    });

    function usesCustomIndicator($row) {
        const indicatorId = ($row.find('.poa-line-indicator-id').val() || '').toString().trim();
        const indicatorText = ($row.find('.poa-line-indicator-text').val() || '').toString().trim();
        const selectedIndicator = ($row.find('.indicator-select').val() || '').toString().trim();

        return !indicatorId && (indicatorText.length > 0 || selectedIndicator === 'other');
    }

    $(document).on('input', '.poa-line-meta', function () {
        const $row = $(this).closest('.poa-line');
        if (!usesCustomIndicator($row)) return;

        $row.find('.poa-line-amount_p1').val($(this).val());
    });

    $(document).on('input', '[name*="amount_p"], [name*="meta"]', function () {
        const $row = $(this).closest('.poa-line');
        const $submits = $('.js-poa-submit');

        let amountP1 = parseFloat($row.find('[name*="amount_p1"]').val()) || 0;
        let amountP2 = parseFloat($row.find('[name*="amount_p2"]').val()) || 0;
        let amountP3 = parseFloat($row.find('[name*="amount_p3"]').val()) || 0;
        let amountP4 = parseFloat($row.find('[name*="amount_p4"]').val()) || 0;
        let meta = parseFloat($row.find('[name*="meta"]').val()) || 0;
        // si faltan campos (p.ej. anual), no bloqueamos
        if (isNaN(amountP1) || isNaN(amountP2) || isNaN(amountP3) || isNaN(amountP4)) return;

        const total = amountP1 + amountP2 + amountP3 + amountP4;
        const errorId = 'amount-error-' + $row.index();
        const $amountError = $row.find('#' + errorId);

        if (total !== meta) {
            if ($amountError.length === 0) {
                $row.find('[name*="meta"]').after(
                    '<div id="' + errorId + '" style="color: red;">La suma de los montos debe ser igual a la meta</div>'
                );
            }
        } else {
            $amountError.remove();
        }

        // deshabilita si hay CUALQUIER mensaje de este tipo en el formulario
        const hasAnyAmountError = $('.poa-line [id^="amount-error-"]').length > 0;
        $submits.prop('disabled', hasAnyAmountError);
    });

    $(document).on('change', '[name*="baseline"]', function () {
        let $poaLine = $(this).closest('.poa-line'); // Encontrar el poa-line contenedor
        let baseline = parseFloat($(this).val());
        updateMeta(baseline, $poaLine);
    });

    function updateMeta(baseline, $row) {
        let poaYear = $('#poa_year').val();
        let indicatorId = ($row.find('.poa-line-indicator-id').val() || '').toString().trim();
        if (baseline && indicatorId && poaYear) {
            $.ajax({
                url: '/calculate_meta',
                method: 'GET',
                data: { baseline: baseline, indicator_id: indicatorId, poa_year: poaYear },
                success: function (response) {
                    $row.find('[name*="meta"]').val(response.meta);
                    $row.find('[name*="amount_p1"]').val(response.meta);
                    $('.js-poa-submit').prop('disabled', false);
                },
                error: function () { console.error('Error al calcular la meta'); }
            });
        }
    }

    function setIndicatorOtherRequired($line, required) {
        const $other = $line.find(".indicator-other");
        if (!$other.length) return;

        $other.prop("required", !!required);

        const hasValue = (($other.val() || "").toString().trim().length > 0);
        if ($other[0] && $other[0].setCustomValidity) {
            if (required && !hasValue) $other[0].setCustomValidity("Debes especificar el indicador cuando seleccionas 'Otro'.");
            else validateLengthLimitedField($other[0]);
        }
    }

    function showIndicatorOther($other) {
        $other.closest('.poa-limited-field').show();
        $other.show();
        validateLengthLimitedField($other[0]);
    }

    function hideIndicatorOther($other) {
        $other.hide();
        $other.closest('.poa-limited-field').hide();
        validateLengthLimitedField($other[0]);
    }

    function applyIndicatorOtherState($line) {
        const id  = ($line.find(".poa-line-indicator-id").val() || "").toString().trim();
        const txt = ($line.find(".poa-line-indicator-text").val() || "").toString().trim();

        const $sel = $line.find(".indicator-select");
        const $other = $line.find(".indicator-other");

        if (!id && txt) {
            if ($sel.find('option[value="other"]').length === 0) $sel.append(new Option("Otro", "other"));
            $sel.val("other");
            showIndicatorOther($other.val(txt));
            setIndicatorOtherRequired($line, true);

            // habilitar meta manual
            $line.find('[name*="[meta]"]').prop('readonly', false);
        } else {
            hideIndicatorOther($other);
            setIndicatorOtherRequired($line, false);
            // si hay indicador real, meta vuelve a readonly (la recalcula el AJAX)
            if (id) $line.find('[name*="[meta]"]').prop('readonly', true);
        }
    }
});
